/**
 * Creates a Svelte store for the specified data type,
 * allowing different components to subscribe and update accordingly
 */

import { writable } from "svelte/store"

import type { Entry, DataHandler, IDMap } from "data-handler"
import type { RawDataOf } from "data-handler/src/types"

export function createDataStore<EntryType extends Entry<RawDataOf<EntryType>>>(
	dataHandler: DataHandler<EntryType>
) {
	const idMappedData: IDMap<EntryType> = {}
	const store = writable<Array<EntryType>>([])

	dataHandler.addListener((changedIds) => {
		for (const id of changedIds) {
			const updatedEntry = dataHandler.get(id)
			if (updatedEntry !== undefined) idMappedData[id] = updatedEntry
			else delete idMappedData[id]
		}
		store.set(Object.values(idMappedData))
	})

	return store
}
